const PAYPAL_SCRIPT_ID = 'paypal-script'

export const loadPayPalScript: (clientId: string, userIdToken: string) => Promise<void> = (
  clientId,
  userIdToken,
) =>
  new Promise((resolve, reject) => {
    const disableFundingSources =
      'card,credit,paylater,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo'
    const src = `https://www.paypal.com/sdk/js?client-id=${clientId}&disable-funding=${disableFundingSources}&locale=en_US&intent=capture&currency=USD`

    const currentScriptTag = document.getElementById(PAYPAL_SCRIPT_ID) as HTMLScriptElement | null
    if (currentScriptTag) {
      currentScriptTag.src = src
      currentScriptTag.setAttribute('data-user-id-token', userIdToken)

      resolve()

      return
    }

    const scriptElement = document.createElement('script')
    scriptElement.src = src
    scriptElement.id = PAYPAL_SCRIPT_ID
    scriptElement.setAttribute('data-user-id-token', userIdToken)

    scriptElement.onload = () => resolve()
    scriptElement.onerror = (error) => reject(error)

    document.head.appendChild(scriptElement)
  })
